import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.002 10C20.002 15.5228 15.5248 20 10.002 20C4.47911 20 0.00195312 15.5228 0.00195312 10C0.00195312 4.47715 4.47911 0 10.002 0C15.5248 0 20.002 4.47715 20.002 10ZM2.50195 10C2.50195 14.1421 5.85982 17.5 10.002 17.5C14.1441 17.5 17.502 14.1421 17.502 10C17.502 5.85786 14.1441 2.5 10.002 2.5C5.85982 2.5 2.50195 5.85786 2.50195 10Z",
      fill: "#F2F2F2"
    }, null, -1)
  ])))
}
export default { render: render }